import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Equality.css';

const Equality = () => {
  return (
    <>
      <Helmet>
        <title>Equality - Diversity, Inclusion & Social Justice | Redbox Global</title>
        <meta name="description" content="Coverage of workplace diversity, gender equality, pay gap progress, accessible technology, LGBTQ+ rights, social justice initiatives, and inclusion programs worldwide." />
        <meta name="keywords" content="equality, diversity and inclusion, gender equality, pay gap, workplace diversity, LGBTQ+ rights, social justice, accessibility, inclusive workplace, DEI initiatives" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/equality" />
        <meta property="og:title" content="Equality - Diversity, Inclusion & Social Justice | Redbox Global" />
        <meta property="og:description" content="Coverage of workplace diversity, gender equality, accessible technology, LGBTQ+ rights, and social justice initiatives." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/equality" />
        <meta name="twitter:title" content="Equality - Diversity, Inclusion & Social Justice | Redbox Global" />
        <meta name="twitter:description" content="Coverage of workplace diversity, gender equality, accessible technology, LGBTQ+ rights, and social justice initiatives." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/equality" />
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Equality</h1>
        <p className="page-subtitle">Social justice, diversity, inclusion, and equality initiatives</p>
      </div>
      
      <div className="page-content">
        <a href="/article/workplace-diversity-progress" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=1200&h=600&fit=crop" alt="Diversity and inclusion" />
            </div>
            <div className="featured-content">
             
              <h2>Breaking Barriers: The State of Workplace Equality</h2>
              <p>A comprehensive look at how companies worldwide are advancing diversity, equity, and inclusion initiatives, and the measurable impact on business performance and employee satisfaction.</p>
              <span className="article-meta">This Week's Feature</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/gender-pay-gap-progress" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=400&fit=crop" alt="Gender equality" />
              </div>
              <div className="article-content">
                
                <h2>Closing the Gender Pay Gap: Progress Report</h2>
                <p>New data reveals which industries are making strides toward equal pay and what's holding others back.</p>
                <span className="article-meta">February 3, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/accessible-technology-innovations" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=600&h=400&fit=crop" alt="Technology accessibility" />
              </div>
              <div className="article-content">
               
                <h2>Technology Innovations for Accessibility</h2>
                <p>How tech companies are designing products that empower people of all abilities.</p>
                <span className="article-meta">February 2, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/lgbtq-rights-global-progress" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop" alt="LGBTQ rights" />
              </div>
              <div className="article-content">
               
                <h2>Global Progress in LGBTQ+ Equality</h2>
                <p>Examining the advances and setbacks in the fight for equal rights worldwide.</p>
                <span className="article-meta">February 1, 2026</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default Equality;
